import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { APP_LINKS } from 'config/core';
import { getFileLink, getPageLink } from 'helpers/resources';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const propTypes = {
  // store
  userIsLoggedIn: PropTypes.bool
};

const FooterNav = ({ userIsLoggedIn }) => {
  return (
    <div className="footer-nav">
      <div className="nav-wrapper">
        <ul>
          <li>
            <LinkNav to={getPageLink('page-about')}>About Us</LinkNav>
          </li>
          <li>
            <LinkNav to={getPageLink('page-leadership-staff')}>
              Leadership
            </LinkNav>
          </li>
          <li>
            <LinkNav to={getPageLink('page-articles-of-organization')}>
              Articles of Organization
            </LinkNav>
          </li>
          {!userIsLoggedIn && (
            <li>
              <LinkNav to={getPageLink('page-login')}>Member Login</LinkNav>
            </li>
          )}
          <li>
            <LinkNav to={APP_LINKS.google}>Mobile App</LinkNav>
          </li>
        </ul>
      </div>
      <div className="nav-wrapper">
        <ul>
          <li>
            <LinkNav to={getPageLink('page-faqs')}>FAQs</LinkNav>
          </li>
          <li>
            <LinkNav
              to={getFileLink('file-credit-auth')}
              data-gtm-cc-authorization-form-link
            >
              <i className="icon-pdf" aria-hidden="true"></i>
              {'  '}
              Credit Card Authorization Form
            </LinkNav>
          </li>
          <li>
            <LinkNav
              to={getFileLink('file-beneficiary-designation-form')}
              data-gtm-beneficiary-designation-form-link
            >
              <i className="icon-pdf" aria-hidden="true"></i>
              {'  '}
              Beneficiary Designation Form
            </LinkNav>
          </li>
          <li>
            <LinkNav
              to={getFileLink('file-eft-form')}
              data-gtm-electronic-funds-transfer-form-link
            >
              <i className="icon-pdf" aria-hidden="true"></i>
              {'  '}
              Electronic Funds Transfer
            </LinkNav>
          </li>
          <li>
            <LinkNav
              to={getFileLink('file-request-for-allotment')}
              data-gtm-allotment-request-form-link
            >
              <i className="icon-pdf" aria-hidden="true"></i>
              {'  '}
              Allotment Request Form
            </LinkNav>
          </li>
          <li>
            <LinkNav
              to={getFileLink('file-metlaw-mba-enrollment-fillable-2024')}
              data-gtm-metlaw-legal-services-form-link-2024
            >
              <i className="icon-pdf" aria-hidden="true"></i>
              {'  '}
              MetLife Legal Plans
            </LinkNav>
          </li>
        </ul>
      </div>
    </div>
  );
};

FooterNav.propTypes = propTypes;

const mapStateToProps = state => ({
  userIsLoggedIn: _get(state, 'user.isLoggedIn')
});

export default connect(mapStateToProps)(FooterNav);
